import React from 'react';
import '../css/index.css';

export function Footer() {

    return (
        <footer>
            <p>Copyright © {(new Date().getFullYear())} University of Washington - Statistics Probability Association</p>
        </footer>
    )
}